import styled from 'styled-components'

export const Modal = styled.div`
  position: absolute;
  width: 100vw;
  top: 0;
  height: 100vh;
  z-index: 30000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);

  .content {
    position: relative;
    width: 50%;
    padding: 0 0 0 20px;

    .logout {
      background-color: #002b80;
      border-radius: 500px;
      color: #ffffff;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      cursor: pointer;
      right: 20px;
      border: none;
      top: 10px;
      z-index: 500000;
      font-family: 'Montserrat', sans-serif;
    }

    .header {
      background: #002b80;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      border-radius: 27px 27px 0 0;
      font-size: 18px;
      font-weight: 700;
      font-family: 'Montserrat', sans-serif;
      text-transform: capitalize;
    }

    .resume {
      border-radius: 27px;
      display: flex;
      gap: 20px;
      flex-direction: column;
      padding: 50px 20px;
      background-color: #ffffffff;
      height: 100%;
      border-radius: 0 27px 27px 27px;

      .resume-content {
        display: flex;
        gap: 10px;
        flex-direction: column;
        h3 {
          width: 100%;
          text-align: center;
        }
      }
    }

    .buttons {
      display: flex;
      gap: 20px;
      margin-top: 10px;
      width: 100%;
      justify-content: center;

      button,
      label {
        width: 100px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        border-radius: 27px;
        cursor: pointer;
        font-family: 'Montserrat', sans-serif;
        font-size: 12px;
        font-weight: 700;
        color: #ffffff;
      }

      .cancel {
        background-color: #990000;
      }

      .edit {
        background-color: #00205b;
      }

      .ok {
        transition: all ease-in-out 400ms;
        background-color: #274e13;
        &:disabled {
          background-color: #7e7e7e93;
          transition: all ease-in-out 1s;
        }
      }
    }
  }
`

export const ModalContent = styled.div`
  width: 40%;
  height: 50%;
  animation: showModal 1s;

  @keyframes showModal {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const ModalClose = styled.div`
  width: 100%;
`

export const ModalAdmStyle = styled.div`
  width: 90%;
  height: 80%;
  margin-top: 120px;

  select {
    height: 40px;
    border: none;
    border-radius: 27px;
    width: 427px;
    padding: 0 10px;
    box-shadow: 0px 2px 30px 1px rgba(0, 0, 0, 0.2);

    &:focus {
      outline: none;
    }
  }

  input {
    height: 40px;
    border: none;
    border-radius: 27px;
    width: 427px;

    padding: 0 10px;
    box-shadow: 0px 2px 30px 1px rgba(0, 0, 0, 0.2);

    &:focus {
      outline: none;
    }
  }

  .header {
    background: #002b80;
    width: 100%;
    height: 48px;
    border-radius: 27px 27px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    color: #ffffff;
  }

  .content {
    height: 90%;
    position: relative;
    width: 90%;

    .camp {
      font-size: 16px;
      font-weight: 600;
      font-family: 'Montserrat', sans-serif;
      width: 100%;
      background-color: ${(props) => props.theme.background};
      border-radius: 0 0 27px 27px;
      box-shadow: 0px 2px 30px 1px rgba(0, 0, 0, 0.2);
      height: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #001f5b;
      gap: 10px;
      overflow-y: auto;
      padding: 20px;
      .cod {
        input {
          text-align: center;
          width: 60px;
        }
      }

      .name {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;

        p {
          color: #ffffff;
        }

        .password {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .photo {
          width: 130px;
          height: 130px;
          font-size: 15px;
          font-weight: 600;
          background-color: #00246b3a;
          color: #001f5b;
          border-radius: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-transform: uppercase;
        }
      }

      .buttonCreated {
        background: #002b80;
        box-shadow: 0px 2px 30px 1px rgba(0, 0, 0, 0.2);
        color: #ffffff;
        border-radius: 27px;
        font-family: 'Montserrat', sans-serif;
        font-weight: 600;
        font-size: 16px;
        border: none;
        width: 140px;
        cursor: pointer;
        height: 40px;
        padding: 10px 10px;
      }

      .solo {
        display: flex;
        justify-content: center;
        width: 100%;
        flex-direction: column;
      }
    }
  }

  .logout {
    background-color: transparent;
    border: none;
    border-radius: 500px;
    color: #ffffff;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    cursor: pointer;
    right: 20px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        border-radius: 27px;
        cursor: pointer;
        font-family: 'Montserrat', sans-serif;
        font-size: 12px;
        font-weight: 700;
        color: #ffffff;
      }

      .cancel {
        background-color: #990000;
      }

      .edit {
        background-color: #00205b;
      }

      .ok {
        transition: all ease-in-out 400ms;
        background-color: #274e13;
        &:disabled {
          background-color: #7e7e7e93;
          transition: all ease-in-out 1s;
        }
      }
    }
  }
`



export const ModernModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 15, 40, 0.7);
  backdrop-filter: blur(10px);
  z-index: 35000;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  animation: fadeIn 0.25s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`

export const ModernVerticalModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #001842;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 24px 0 0 24px;
  box-shadow: -10px 0 50px rgba(0, 0, 0, 0.6);
  animation: slideInRight 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;

  @keyframes slideInRight {
    from { transform: translateX(100%); }
    to { transform: translateX(0); }
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;
    background: #002b80;

    h3 {
      font-size: 15px;
      font-weight: 700;
      letter-spacing: 0.5px;
      color: #ffffff;
      text-transform: uppercase;
      font-family: 'Montserrat', sans-serif;
    }

    .btn-back {
      position: absolute;
      left: 20px;
      background: transparent;
      border: none;
      color: #94a3b8;
      cursor: pointer;
      font-size: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.2s ease;

      &:hover {
        color: #ffffff;
      }
    }

    .btn-close {
      position: absolute;
      right: 20px;
      background: transparent;
      border: none;
      color: #94a3b8;
      cursor: pointer;
      font-size: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.2s ease;

      &:hover {
        color: #ffffff;
      }
    }
  }

  .body {
    padding: 24px 32px 32px 32px;
    overflow-y: auto;
    max-height: calc(100vh - 64px);
    display: flex;
    flex-direction: column;
    gap: 20px;

    /* Scrollbar */
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 10px;
    }
  }

  .form-section-title {
    font-size: 11px;
    font-weight: 800;
    color: #3b82f6;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    margin-top: 10px;
    margin-bottom: -5px;
    border-left: 3px solid #3b82f6;
    padding-left: 8px;
  }
`

export const ModalFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
`

export const ModalLabel = styled.label`
  font-size: 11px;
  font-weight: 700;
  color: #cbd5e1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const ModalInput = styled.input`
  height: 44px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(0, 0, 0, 0.25);
  color: #ffffff;
  padding: 0 16px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  transition: all 0.2s ease;

  &::placeholder {
    color: #94a3b8;
  }

  &:focus {
    outline: none;
    border-color: #3b82f6;
    background: rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const ModalSelect = styled.select`
  height: 44px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(0, 0, 0, 0.35);
  color: #ffffff;
  padding: 0 16px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    background: rgba(0, 0, 0, 0.5);
  }

  option {
    background: #001842;
    color: #ffffff;
  }
`

export const SubmitButton = styled.button`
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  padding: 14px 28px !important;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8) !important;
  color: #ffffff !important;
  border: none !important;
  outline: none !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  font-family: 'Montserrat', sans-serif !important;
  cursor: pointer !important;
  transition: all 0.25s ease !important;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.25) !important;
  margin-top: 20px !important;
  margin-bottom: 10px !important;

  &:hover {
    background: linear-gradient(135deg, #60a5fa, #2563eb) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4) !important;
  }

  &:active {
    transform: translateY(1px) !important;
  }

  &:disabled {
    background: #334155 !important;
    color: #64748b !important;
    cursor: not-allowed !important;
    transform: none !important;
    box-shadow: none !important;
  }
`
